import { TranslateService } from '@ngx-translate/core';
import { VariableTableField, VariablesTableColumn } from '../models';

export function createVariablesTableColumns(translateService: TranslateService): VariablesTableColumn[] {
  return [
    {
      field: VariableTableField.KEY,
      header: translateService.instant('workflow.variables.tree.columns.name'),
      width: '25%',
      sortable: true,
    },
    {
      field: VariableTableField.VALUE,
      header: translateService.instant('workflow.variables.tree.columns.value'),
      width: '15%',
      sortable: true,
    },
    {
      field: VariableTableField.REGEX_RULE,
      header: translateService.instant('workflow.variables.tree.columns.regex'),
      width: '12%',
      sortable: true,
    },
    {
      field: VariableTableField.DESCRIPTION,
      header: translateService.instant('workflow.variables.tree.columns.description'),
      width: '15%',
      sortable: true,
    },
    {
      field: VariableTableField.MODIFIED,
      header: translateService.instant('workflow.variables.tree.columns.modified'),
      width: '10%',
      sortable: true,
    },
    {
      field: VariableTableField.CREATED_AUTHOR,
      header: translateService.instant('workflow.variables.tree.columns.author'),
      width: '8%',
      sortable: true,
    },
    {
      field: VariableTableField.USED,
      header: translateService.instant('workflow.variables.tree.columns.used'),
      sortable: true,
    },
    {
      field: VariableTableField.ACTIONS,
      header: translateService.instant('workflow.variables.tree.columns.actions'),
    },
  ];
}
